import { GraphQLClient } from 'graphql-request'
import Queries from './graphql/queries'

function getResidentialTemplates(payload) {
  return new GraphQLClient('/api/graphql')
    .request(Queries.ResidentialTemplatesSearch, payload)
    .then(data => data.ResidentialTemplates)
}

export { getResidentialTemplates }
